export const invoiceNotPaid = {
  acceptableValues: [
    "invoiceReadyNoTransportBookedNotEligibleForDelivery",
    "invoiceReadyNoTransportBooked",
    "invoiceReadyNoTransportOptions",
    "invoiceReadyDeliveryCancelled",
    "invoiceReadyDeliveryBooked",
    "paymentFailedNoTransportOptions",
    "paymentFailedNoTransportBookedNotEligibleForDelivery",
    "paymentFailedDeliveryCancelled",
    "paymentFailedNoTransportBooked",
    "PartnerFinanceFailed",
  ],
  deliveryAlert: null,
  collectionsAlert: "Please pay this vehicle to book a collection",
  collectionsCta: "Pay invoice",
  collectionsLink: null,
};

export const invoicePaid = {
  acceptableValues: [
    "paymentProcessingNoTransportBooked",
    "paymentProcessingDeliveryBooked",
    "invoicePaidNoTransportBookedIsOffsiteTrue",
    "invoicePaidNoTransportBooked",
  ],
  deliveryAlert:
    "This vehicle invoice is paid, delivery request will be generated as a Sundry invoice",
  collectionsAlert: null,
  collectionsCta: "Book collection",
  collectionsLink: `${process.env.VIRTUAL_DOMAIN}mybca/collections`,
  collectionsAction: null,
};

export const partnerFinance = {
  acceptableValues: [
    "PartnerFinanceProcessing",
    "partnerFinanceInvoiceNoTransportBooked",
    "partnerFinanceInvoiceNoTransportBookedIsOffsiteTrue",
  ],
  deliveryAlert:
    "This vehicle invoice is paid via Partner Finance. The delivery request will be generated as a Sundry invoice and CAN NOT be partner financed",
  collectionsAlert: null,
  collectionsCta: "Book collection",
  collectionsLink: `${process.env.VIRTUAL_DOMAIN}mybca/collections`,
  collectionsAction: null,
};
